import { useEffect } from 'react';
import {
  Dialog,
  ButtonSize,
  Typography,
  ButtonVariant,
  PrimaryButton, 
} from '@uni-of-exeter/digital.lib.react.ui.kit';
import './hide-recommendation-modal.css';
import { APP_TEXT } from '../../const/app-text';

export interface HideRecommendationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const text = APP_TEXT.components.hideRecommendationModal;

const HideRecommendationModal = ({ isOpen, onClose, onConfirm }: HideRecommendationModalProps) => {
  useEffect(() => {
    if (isOpen) {
      const rootElement = document.getElementById('root');
      if (!rootElement) {
        return;
      }
      rootElement.style.filter = 'blur(4px)';
    } else {
      const rootElement = document.getElementById('root');
      if (!rootElement) {
        return;
      }
      rootElement.style.filter = '';
    }
  }, [isOpen]);

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      footer={<></>}
      className="hideRecommendationModal"
      aria-modal="true"
      aria-label={text.accessibility.dialogAriaLabel}
    >
      <div
        className="hideRecommendationModalWrapper"
      >
        <div className="hideRecommendationModalContent">
          <Typography variant="h4">
            {text.title}
          </Typography>

          <div className="contentBody">
            <Typography variant="body.small" element="p">
              {text.body} <b>{text.bodyBold}</b>
            </Typography>
          </div>
        </div>

        <div className="hideRecommendationModalButton">
          <PrimaryButton
            tabIndex={0}
            variant={ButtonVariant.Solid}
            size={ButtonSize.Large}
            onClick={onConfirm}
            aria-label={text.close}
            aria-description={text.accessibility.btnAriaDescription}
          >
            {text.close}
          </PrimaryButton>
        </div>
      </div>
    </Dialog>
  );
};

export default HideRecommendationModal;
